import { render, staticRenderFns } from "./EquipamentoChart.vue?vue&type=template&id=4979b2ef&"
import script from "./EquipamentoChart.vue?vue&type=script&lang=js&"
export * from "./EquipamentoChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports